import styled from 'styled-components';

export const StepsChartSC = styled.div`
  .sc-header {
    color: #ffffff;
    margin-bottom: 10px;

    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .meta {
        position: absolute;
        top: 26px;
      }
      svg {
        opacity: 0.6;
        width: 24px;
        height: 24px;
        margin-right: 8px;
        path {
          fill: white;
        }
      }
    }
  }

  .custom-tooltip {
    background: rgba(51, 61, 108, 0.9);
    outline: none;
    box-shadow: none;
    border-radius: 5px;
    color: white;
    padding: 10px;
    div {
      &:focus-visible {
        outline: none;
      }
    }

    p {
      margin: 0;
      font-size: 12px;
      line-height: 18px;
      font-weight: 700;
    }
  }

  .chart-legend {
    display: flex;
    align-items: center;
    &__item {
      font-size: 12px;
      color: #ffffff;
      display: flex;
      align-items: center;
      margin-right: 20px;
      .circle {
        width: 10px;
        height: 10px;
        display: block;
        border-radius: 10px;
        margin-right: 10px;
        &.grey {
          background: rgba(255, 255, 255, 0.7);
        }
        &.blue {
          background: rgba(106, 213, 229, 0.7);
        }
      }
    }
  }

  .no-data {
    width: calc(100% - 120px);
    height: 167px;
    margin: 62px 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.5);
    border-radius: 20px;
    svg {
      margin-bottom: 14px;
    }
  }
`;

export const StepCartSummarySC = styled.div`
  width: 100%;
  color: #ffffff;
  .progress-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 25px 0 30px 0;
    .progress {
      width: 120px;
      height: 84px;
      margin-left: -20px;
      display: flex;
      justify-content: center;
      position: relative;
      .count {
        position: absolute;
        transform: translate(-50%, -50%);
        left: 50%;
        top: 50%;
        font-size: 18px;
        font-weight: 800;
        &.empty {
          font-size: 15px;
          font-weight: 600;
        }
      }
      svg {
        margin-top: -15px;
      }
      span {
        display: none;
      }
    }
    .count-global {
      font-size: 30px;
      font-weight: 400;
    }
  }
  .average {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(217, 217, 217, 0.1);
    padding-top: 25px;
    padding-bottom: 20px;

    .label {
      font-size: 14px;
      font-weight: 700;
    }
    .count {
      font-size: 30px;
      font-weight: 400;
    }
  }
  .detailed {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 20px;
    padding-bottom: 8px;

    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 0;
      .label,
      .count {
        font-size: 14px;
        font-weight: 700;
        svg {
          margin-top: -4px;
          margin-left: 4px;
          margin-right: 4px;
        }
      }
      .spacer {
        display: flex;
        flex: 1;
        border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
        margin-bottom: -8px;
        margin-left: 10px;
        margin-right: 10px;
      }
    }
  }
`;
